module.exports = __webpack_public_path__ + "dbea59051fc8d72c401aeefacdf18fec.svg";